<div class="modal-container">
    <div class="modal-header">
        <h3>{{ title }}</h3>
    </div>

    <div class="modal-body">
        <div class="section-title">{{ label }}</div>

        <div class="item-list">
            <div class="item" *ngFor="let item of items">
                <div class="item-name">{{ item.name }}</div>
                <div class="quantity-controls">
                    <!-- Decrease Button -->
                    <button
                        [class.active]="item.qty > 0"
                        (click)="decrement(item)"
                        [disabled]="item.qty <= 0"
                        [attr.title]="item.qty <= 0 ? 'Minimum 0' : null"
                    >
                        −
                    </button>
                    <!-- Quantity Display -->
                    <input
                        type="text"
                        class="qty-box"
                        [(ngModel)]="item.qty"
                        (input)="onQtyInput(item, $event)"
                        (keypress)="blockNonNumbers($event)"
                        (blur)="fixQty(item)"
                    />

                    <!-- Increase Button -->
                    <button
                        [class.active]="item.qty >= 0"
                        (click)="increment(item)"
                        [disabled]="item.qty >= item.maxqty"
                        [attr.title]="item.qty >= item.maxqty ? 'Reached max limit' : null"
                    >
                        +
                    </button>
                </div>
            </div>
        </div>

    </div>

    <div class="modal-footer">
        <button class="cancel-btn" (click)="bsModalRef.hide()">Cancel</button>
        <button class="confirm-btn" [disabled]="!isFormValid()" (click)="markAsReturn()">{{ saveLabel }}</button>
    </div>
</div>
